module.exports = __webpack_public_path__ + "img/no-results-emoji.png";